import { styled } from "styled-components";
import { Button, Image, Text } from "@chakra-ui/react";
import { useEffect, useState } from "react";

import { convertFontSize } from "./Util";
import arrowLeft from "../assets/icons/icon-arrow-tail-left.png";
import arrowRight from "../assets/icons/icon-arrow-tail-right.png";

const SwiperContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: start;
  width: 80%;
  min-height: 300px;
  height: 300px;
  max-height: 300px;
  overflow: hidden;
  margin-left: 20%;

  @media (max-width: 1024px) {
    width: 95%;
    margin-left: 5%;
  }
`;

const StyledSwiper = styled.div<{ $move: number }>`
  display: flex;
  width: 100%;

  transform: translateX(-${(props)=>props.$move}px);
  transition: transform 0.5s ease-in-out;
`;

const StyledSlide = styled.div`
  min-width: fit-content;
  margin: 0 15px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;

  img {
    max-height: 144px;
    object-fit: contain;
  }
`;

const ControllBox = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  margin-top: 50px;
  padding: 0 15% 0 15px;

  @media (max-width: 1024px) {
    margin-top: 10%;
    padding: 0 5% 0 15px;
  }

`;

const ProgressBox = styled.div`
  width: 80%;
  height: 1px;
  margin-right: 5%;
  background-color: #A1A1A1;
  display: flex;
  align-items: center;

  @media (max-width: 768px) {
    width: 70%;
  }
`;

const ProgressBar = styled.div<{ width: number }>`
  width: ${(props) => props.width + '%'};
  height: 3px;
  background: #6D6D6D;
  border-radius: 1px;
  transition: width 0.3s ease;
`;

const ProgressSlider = ({
  datas,
}) => {
  const [isFirst, setIsFirst] = useState<boolean>(true);
  const [domainIndex, setDomainIndex] = useState<number>(0);
  const max = document.querySelectorAll('.domain').length;
  const [move, setMove] = useState<number>(0);

  const handlePrev = (e) => {
    if(domainIndex === 0) return;
    setDomainIndex(prev => prev - 1);
  };  

  const handleNext = (e) => {
    if(domainIndex === max - 1) return;
    setDomainIndex(prev => prev + 1);
  };  

  useEffect(() => {
    if(isFirst) {
      setIsFirst(false);
      return;
    }
    const domainList = document.querySelectorAll('.domain');
    const domain = domainList[domainIndex];
    const width = domain.clientWidth;
    setMove((width + 30) * domainIndex);
    // if (domain instanceof HTMLElement) {
      // domain.scrollIntoView({ behavior: 'smooth', block: "nearest", inline: "start" });
    // }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [domainIndex]);

  return (
    <SwiperContainer>
      <StyledSwiper $move={move}>
        {datas?.map((item, index) => {
          return (
            <StyledSlide key={index} className="domain">
              <Image src={item.image} width={"auto"} height={"100%"} alt="" />
              <Text color={"#121212"} fontSize={convertFontSize(16, 20)} mt={"5%"}>{item.title}</Text>
            </StyledSlide>
          )
        })}
      </StyledSwiper>
      <ControllBox>
        <ProgressBox>
          <ProgressBar width={(domainIndex / (datas?.length - 1)) * 100} />
        </ProgressBox>
        <Button 
          w={"10%"}
          onClick={handlePrev} 
          backgroundImage={arrowLeft} 
          backgroundRepeat={"no-repeat"} 
          backgroundPosition={"center"}
          backgroundColor={"transparent"}
          _hover={{
            backgroundImage: arrowLeft,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            backgroundColor: "transparent",
          }}
        />
        <Button 
          w={"10%"}
          onClick={handleNext}
          backgroundImage={arrowRight} 
          backgroundRepeat={"no-repeat"} 
          backgroundPosition={"center"}
          backgroundColor={"transparent"}
          _hover={{
            backgroundImage: arrowRight,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            backgroundColor: "transparent",
          }}
        />
      </ControllBox>
    </SwiperContainer>
  );
};

export default ProgressSlider;